import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { EngineApiClient } from './api-clients/engine.api-client';
import { Provider } from '../models/signatureProvider';

/**
 * Service that you can use to start have Signatures Providers from the engine
 */
@Injectable({ providedIn: 'root' })
export class EngineService {
    
    constructor(private engineApiClient: EngineApiClient) { }

    public async getSignatureProviders(): Promise<Provider[]> {
        try {
            const providers: Provider[] = await lastValueFrom(this.engineApiClient.getSignatureProviders());
            return providers;
        } catch (error) {
            console.error(error);
            return [];
        }
    }
}